import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const CollegeCourt = () => {
  return <SingleContentPage title="College Court" moduleKey="college-court" />;
};

export default CollegeCourt;
